import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderService } from '@core/services/loader.service';
import { ConfigPresorteo } from '../../../models/config-pesorteo.model';
import { ConfigPresorteoService } from '../../../services/configPresorteo/config-presorteo.service';

@Component({
  selector: 'app-page-config-presorteo-list',
  templateUrl: './page-config-presorteo-list.component.html',
  styleUrls: ['./page-config-presorteo-list.component.scss']
})
export class PageConfigPresorteoListComponent implements OnInit {

  configPresorteos: ConfigPresorteo[] = [];
  constructor(
    private loadService: LoaderService,
    private router: Router,
    private configPresorteoService: ConfigPresorteoService,
  ) { }

  ngOnInit(): void {
    this.getConfigs();
  }

  getConfigs(): void {
    this.loadService.show();
    this.configPresorteoService.getConfigPresorteos()
    .then(response => {
      if (response.success) {
        this.configPresorteos = response.data;
      }
    })
    .finally(() => {
      this.loadService.hide();
    });
  }

  goToCreate(): void {
    this.router.navigate(['presorteo/megaloto/config-presorteo/create']);
  }

}
